import { useEffect, useRef } from "react";
import { LoaderCircle } from "lucide-react";
import { Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "../../lib/use-admin-auth";

const PLATFORM_URL = "https://portal.forhandlerborsen.no";

export function RequireAdmin() {
  const { sessionData, isPending, bootstrapLoading, bootstrapComplete, isAdmin } = useAdminAuth();
  const hasRenderedRef = useRef(false);

  useEffect(() => {
    if (sessionData?.user && !isPending && bootstrapComplete && !bootstrapLoading && !isAdmin) {
      window.location.replace(PLATFORM_URL);
    }
  }, [bootstrapComplete, bootstrapLoading, isAdmin, isPending, sessionData?.user]);

  // Once children have mounted, keep them mounted through background session
  // revalidations (e.g. on tab focus) so in-progress form state isn't wiped.
  if (hasRenderedRef.current) {
    if (!isPending && !sessionData?.user) {
      return <Navigate to="/auth/login" replace />;
    }
    return <Outlet />;
  }

  if (isPending || (sessionData?.user && (!bootstrapComplete || bootstrapLoading))) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <LoaderCircle className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!sessionData?.user) {
    return <Navigate to="/auth/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <LoaderCircle className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  hasRenderedRef.current = true;
  return <Outlet />;
}
